import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
};

const authSlice = createSlice({ 
  name: "auth",
  initialState,

  reducers: {
    persistAuth: (state, {payload}) => {
      state.user = payload;
    },
    removeUser: (state) => {
      state.user = null;
    },
    profile: (state, {payload}) => {
      state.user = payload;
    }
  },
});

export default authSlice.reducer;
export const { removeUser, persistAuth } = authSlice.actions;